export default __webpack_public_path__ + "static/media/07-BB-(5-3).a1250fe5.jpg";